import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllCompanyPrefs = (filters = {}) => {
  const query_string = new URLSearchParams(filters).toString();
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/companypref?${query_string}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneCompanyPref = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/companypref/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createCompanyPref = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/companypref/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateCompanyPref = (id, data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/companypref/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteCompanyPref = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/companypref/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchCurrentCompanyPref = () => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/companypref/current`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};
